import { toKebabCase } from '@tpr/core';
var AccessibilityHelper = (function () {
    function AccessibilityHelper(rootId, hasLabel, hasHint, hiddenLabelId) {
        var _this = this;
        if (hiddenLabelId === void 0) { hiddenLabelId = null; }
        this.rootId = rootId;
        this.hasLabel = hasLabel;
        this.hasHint = hasHint;
        this.hiddenLabelId = hiddenLabelId;
        this.formatAriaDescribedBy = function (isError) {
            var describedBy;
            if (isError) {
                describedBy = (_this.hintId || '') + " " + (_this.errorId || '');
            }
            else {
                describedBy = "" + (_this.hintId || '');
            }
            return describedBy.trim() || null;
        };
        this.rootId = toKebabCase(rootId);
    }
    Object.defineProperty(AccessibilityHelper.prototype, "labelId", {
        get: function () {
            return ((this.rootId && this.hasLabel && this.rootId + "-label") ||
                this.hiddenLabelId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessibilityHelper.prototype, "hintId", {
        get: function () {
            return (this.rootId && this.hasHint && this.rootId + "-hint") || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessibilityHelper.prototype, "errorId", {
        get: function () {
            return (this.rootId && this.rootId + "-error") || null;
        },
        enumerable: false,
        configurable: true
    });
    return AccessibilityHelper;
}());
export default AccessibilityHelper;
//# sourceMappingURL=accessibilityHelper.js.map